<template>
    <div>
        <div v-if="loading" class="text-center p-5">Loading banner...</div>
    
        <div v-else>
            <div v-if="!banners || Object.keys(banners).length === 0" class="text-center text-muted p-4 border rounded">
                No banner available.
            </div>
            <table class="table">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Sub Title</th>
                        <th>Date</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ banners.Title }}</td>
                        <td>{{ banners.SubTitle }}</td>
                        <td>{{ formatDate(banners.CreatedTime) }}</td>
                        <td>
                            <div class="d-flex justify-content-end align-items-center gap-2">
                                <img src="../../assets/img/edit-btn.png" width="30px" class="mr-1" @click="editBanner(banners)" />
                                <img src="../../assets/img/delete-btn.png" width="30px" @click="deleteBanner(banners)" />
                            </div>
    
                        </td>
                    </tr>
                </tbody>
            </table>
    
            <div v-if="updateBanner" class="upload-popup-overlay" @click="closePopup">
                <div class="upload-popup-card" @click.stop>
                    <button class="close-btn" @click="closePopup">×</button>
    
                    <br />
                    <div class="text-left">
                        <CInput v-model="title" label="Title" />
                        <CTextarea v-model="description" label="Description" rows="9" />
                    </div>
                    <div class="d-flex justify-content-end gap-2">
                        <CButton color="secondary" class="custom-btn-grey text-dark m-1" @click="closePopup">
                            Cancel
                        </CButton>
                        <CButton color="primary" class="btn-modern m-1" @click="updateClass()">
                            Save Changes
                        </CButton>
                    </div>
    
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "BannerListPopup",
    props: ["data"],
    data() {
        return {
            banners: [],
            loading: false,

            //editbanner
            title: "",
            description: "",
            selectedBannerId: null,
            updateBanner: false,
            lblBtn: "Proceed",
            Error: false,
            Message: "",
        };
    },
    async mounted() {
        this.GetBanner();
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return "-";
            const d = new Date(dateStr);
            return d.toLocaleDateString("en-MY", { year: "numeric", month: "short", day: "numeric" });
        },
        GetBanner() {
            return this.$API
                .get(this.$GetBannerView)
                .then((response) => {
                    if (response.status == 200) {
                        this.banners = response.data;
                    }
                });
        },
        editBanner(item) {
            if (!item) return;

            this.selectedBannerId = item.Id;
            this.title = item.Title || "";
            this.description = item.SubTitle || "";
            this.updateBanner = true; // ✅ show popup
        },
        async updateClass() {
            this.lblBtn = "Processing";
            this.Error = false;

            const formData = new FormData();
            formData.append("Id", this.selectedBannerId); // ✅ Correct ID
            formData.append("Title", this.title);
            formData.append("SubTitle", this.description);
            formData.append("Status", "published");

            try {
                const response = await this.$API.post(this.$CreateBannerText, formData, { withCredentials: true });
                if (response.status === 200) {
                    this.lblBtn = "Proceed";
                    alert("✅ Banner updated successfully.");

                    this.updateBanner = false;
                    this.GetBanner(); // refresh
                    this.closePopup();

                } else {
                    alert("❌ Error updating banner.");
                }
            } catch (error) {
  this.Error = true;
  this.Message =
    (error && error.response && error.response.data && error.response.data.message)
      ? error.response.data.message
      : "Unknown error";
  alert("⚠️ " + this.Message);
}
        },
        closePopup() {
            this.updateBanner = false;
        },
        async deleteBanner(item) {
      if (!item?.Id) return;

      if (!confirm("Are you sure you want to delete this banner?")) return;

      const formData = new FormData();
      formData.append("Id", item.Id);
      formData.append("Title", this.title);
            formData.append("SubTitle", this.description);
            formData.append("Status", "published");

      try {
        const response = await this.$API.post(this.$CreateBannerText, formData, {
          withCredentials: true,
        });
        if (response.status === 200) {
          alert("🗑️ Banner deleted successfully.");
          this.GetBanner(); // Refresh list
        } else {
          alert("❌ Failed to delete banner.");
        }
      } catch (error) {
        console.error(error);
        alert("⚠️ Error deleting banner.");
      }
    },

    }
};
</script>